export default __webpack_public_path__ + "static/media/236.c82738bc.jpg";